import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import CoreFeature from './CoreFeature';

function Leads() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);



  return (


    <>
      <Helmet>
        <title>Boost Your Business with Taskflier's Lead Management Software.</title>
      </Helmet>
        <div class="block-style-thirtySix bg-white lg-container pt-110 border-bottom" id="feature">
          <div class="container">
            <div class="row">
              <div class="col-xl-6 col-lg-7  aos-init aos-animate" data-aos="fade-left">
                <div class="pl-lg-5">
                  <div class="title-style-fourteen">
                    <h6><span class="upper-title custom-name">leads Management</span></h6>
                    <h1>Seamlessly manage leads for greater sales success
                    </h1>
                  </div>
                  <div class="tag-line">Your sales pipeline starts with leads. And TaskFlier's <strong>Lead management software</strong> makes it easy to track, organize, and nurture every lead. With a comprehensive executive management component, This efficient lead management tool helps you turn prospects into customers by efficiently following up on them. Data-driven decision-making and efficiency in operations
                  </div>

                  <h4>Why Go for TaskFlier for Your Lead Management Needs?</h4>
                  <div class="tag-line">We managed to design an advanced lead management system that changes how companies manage sales pipelines. With its simple yet complete design, the troubles for companies of all scales are solved with our software.
                  </div>

                </div>
              </div>
              <div class="col-xl-6 col-lg-5 text-center text-lg-left  aos-init aos-animate" data-aos="fade-right">
                <div class="illustration-holder d-inline-block md-mt-60">
                  <img src="/main/images/features/lead-management-software.jpg" alt="Lead Management Software" class="" />
                  {/* <img src="/images/assets/ils_23.1.svg" alt="" class="shapes shape-one"/>
            <img src="/images/assets/ils_23.2.svg" alt="" class="shapes shape-two"/>
            <img src="/images/assets/ils_23.3.svg" alt="" class="shapes shape-three"/> */}
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="fancy-feature-sixteen pt-80 pb-120  md-mt-100 bg-white" id="feature">
          <div class="container">

            <div class="title-style-fourteen">


              <h1 class="pr-xl-5 text-center font-28 ">Key Benefits of Using Our Lead Management System</h1></div>
            <div class="row justify-content-between mb-5">
              <div class="col-lg-4 col-md-6 aos-init" data-aos="fade-up">
                <div class="block-style-thirtyOne mt-40">
                  <div class="icon d-flex align-items-end"><img src="/main/images/features/lead-monitoring.jpg" width={"50px"} alt="Effortless Lead Monitoring" /></div>
                  <h4>Effortless Lead Monitoring</h4>
                  <p>Monitor your leads from the moment they are captured until they are converted with unmatched dexterity and ease.</p>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 aos-init" data-aos="fade-up" data-aos-delay="100">
                <div class="block-style-thirtyOne mt-40">
                  <div class="icon d-flex align-items-end"><img src="/main/images/features/increased-sales-productivity.jpg" width={"50px"} alt="Increased Sales Productivity" /></div>
                  <h4>Increased Sales Productivity</h4>
                  <p>Complete mundane activities through automation, and redirection of the focus of your sales team on achieving targets.</p>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 aos-init" data-aos="fade-up" data-aos-delay="200">
                <div class="block-style-thirtyOne mt-40">
                  <div class="icon d-flex align-items-end"><img src="/main/images/features/improved-customer-relationship.jpg" width={"50px"} alt="Improved Customer Relationship" /></div>
                  <h4>Improved Customer Relationship Management: </h4>
                  <p>Interaction with leads is simple, allowing focus on more important relationships.</p>
                </div>
              </div>


              <div class="col-lg-6 col-md-6 aos-init" data-aos="fade-up" data-aos-delay="100">
                <div class="block-style-thirtyOne mt-40">
                  <div class="icon d-flex align-items-end"><img src="/main/images/features/analytics-powered-intelligence.jpg" width={"50px"} alt="Analytics Powered Intelligence" /></div>
                  <h4>Analytics Powered Intelligence</h4>
                  <p>Acquire analytics on your leads and leverage them to make better decisions.</p>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 aos-init" data-aos="fade-up" data-aos-delay="200">
                <div class="block-style-thirtyOne mt-40">
                  <div class="icon d-flex align-items-end"><img src="/main/images/features/adaptable.jpg" width={"50px"} alt="Adaptable" /></div>
                  <h4>Adaptable to Noida Businesses</h4>
                  <p>When searching for lead management software in Noida, We offer the best available solutions tailored to business needs.</p>
                </div>
              </div>
            </div>



            <div class="title-style-twelve mt-80">
              <div class="row align-items-center">
                <div class="col-lg-5 aos-init aos-animate">
                  <div class="text-wrapper">
                    <h6 className="text-muted mb-2">lead management software</h6>
                    <h3 class="maintitle">About TaskFlier's lead management software</h3>
                    <p className="mainp">
                      This lead management system ensures a systematic approach to leads and their management. This guarantees that opportunities are tracked and followed. Communication tracking, contact management tools, and automated follow-up with TaskFlier can assist your sales team in leveraging account sales and developing your company.
                    </p>
                    <Link class="theme-btn-2 mt-10 md-mt-30" to="/demo-request">
                      Request Now <i class="bi bi-arrow-right pl-2"></i>
                    </Link>
                  </div>
                </div>
                <div class="col-lg-6 offset-lg-1">
                  <div
                    class="screen-holder-two aos-init aos-animate"
                    data-aos="fade-left"
                    data-aos-duration="1200"
                  >
                    <img src="/main/images/features/lead-management.jpg" alt="Lead Management" />                  </div>
                </div>
              </div>
            </div>




          </div>
        </div>

        <div class="fancy-feature-thirtyOne pt-80 pb-100  bg-orange">
          <div class="container">

            <div class="row fixedbox">
              <div class="col-md-4 aos-init" data-aos="fade-up">
                <div class="block-style-thirtyTwo d-block px-4 pt-4">
                  <img src="/main/images/features/lead-profiles.jpg" alt="Lead Profiles" className='w-100 mb-3' />
                  <div class="text p-0">

                    <h4>Comprehensive Lead Profiles



                    </h4>

                    <p className='mainp'>Create detailed content for each lead. Including newsletters, industry, and workplace information. And notes about contacts Store all relevant information in one place. So your organization can better track and stay informed about each individual.</p>

                  </div>
                </div>
              </div>
              <div class="col-md-4 aos-init" data-aos="fade-up">
                <div class="block-style-thirtyTwo d-block px-4 pt-4">
                  <img src="/main/images/features/lead-step-tracking.jpg" alt="Lead Step Tracking" className='w-100 mb-3' />
                  <div class="text p-0"> <h4>Lead Step Tracking </h4>
                    <p>Monitor the advancement of every lead in the sales process. From first contact to final conversion To get a clear view of the status quo. Move leads between sections Using a drag-and-drop interface This makes it easy to see where each prospect stands.</p>

                  </div>
                </div>
              </div>
              <div class="col-md-4 aos-init" data-aos="fade-up">
                <div class="block-style-thirtyTwo d-block px-4 pt-4">
                  <img src="/main/images/features/follow-up-notifications.jpg" alt="Follow-up notifications" className='w-100 mb-3' />
                  <div class="text p-0">

                    <h4>Follow-up notifications are automatic.


                    </h4>
                    <p>Set up automatic notifications for timely follow-up. This lead management tool will ensure that no lead escapes from the cracks. Get information about upcoming or missed tasks for consistent and efficient operations.</p>

                  </div>
                </div>
              </div>
              <div class="col-md-6 aos-init" data-aos="fade-up">
                <div class="block-style-thirtyTwo d-block px-4 pt-4">
                  <img src="/main/images/features/customizable-lead-scoring.jpg" alt="Customizable Lead Scoring" className='w-100 mb-3' />
                  <div class="text p-0">

                    <h4>Customizable lead scoring
                    </h4>
                    <p>Prioritize high-value prospects by assigning ratings based on factors like interest, engagement, and management. And possible income Focus your organization's efforts on high-prospect leads.


                    </p>

                  </div>
                </div>
              </div>
              <div class="col-md-6 aos-init" data-aos="fade-up">
                <div class="block-style-thirtyTwo d-block px-4 pt-4">
                  <img src="/main/images/features/track-communication-history.jpg" alt="Track Communication History" className='w-100 mb-3' />
                  <div class="text p-0">

                    <h4>Track communication history

                    </h4>
                    <p>Record all calls, interactions, and meetings in each manager's directory for a complete communication history. Review each touchpoint regularly to maintain personal and informed interactions with each lead.
                    </p>

                  </div>
                </div>
              </div>
              <div class="col-md-6 aos-init" data-aos="fade-up">
                <div class="block-style-thirtyTwo d-block px-4 pt-4">
                  <img src="/main/images/features/team-collaboration.jpg" alt="Team Collaboration" className='w-100 mb-3' />
                  <div class="text p-0">

                    <h4>Team collaboration and presence

                    </h4>
                    <p>Share leadership information and updates with team members. By giving equal care and effort to leaders. Track progress and notes from multiple team members in one place. So that everyone has the same understanding
                    </p>

                  </div>
                </div>
              </div>

              <div class="col-md-6 aos-init" data-aos="fade-up">
                <div class="block-style-thirtyTwo d-block px-4 pt-4">
                  <img src="/main/images/features/lead-insights-analysis-reporting.jpg" alt="Lead Insights Analysis & Reporting" className='w-100 mb-3' />
                  <div class="text p-0">

                    <h4><Link to="/features/charts-reporting" >Lead insights analysis and reporting.</Link>
                    </h4>
                    <p>Hold meetings on different schedules to work seamlessly with global clients or remote teams. Eliminate scheduling conflicts across time zones. So that everyone is on the same page, no matter where they are.</p>

                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>


        <div class="fancy-feature-thirtySeven bg-white lg-container pt-100 " id="stories">
          <div class="block-style-fortyOne">
            <div class="container">
              <div class="title-style-twelve">
                <div class="row align-items-center">
                  <div class="col-lg-6 aos-init aos-animate">
                    <div class="text-wrapper">

                      <h3 class="maintitle">Increase sales with TaskFlier's lead management tools.</h3>
                      <p className="mainp">
                        With the Lead management feature, you can control your sales pipeline. Improved follow-up and built stronger relationships with potential customers. From lead generation to closing sales this <strong>lead management tool</strong> makes it easy to effectively manage leads and maximize sales success.
                      </p>
                      <Link class="theme-btn-2 mt-10 md-mt-30" to="/demo-request">
                        Request Now <i class="bi bi-arrow-right pl-2"></i>
                      </Link>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div
                      class="screen-holder-two aos-init aos-animate"
                      data-aos="fade-left"
                      data-aos-duration="1200"
                    >
                      <img src="/main/images/features/increase-sales.jpg" alt="Increase sales with TaskFlier" />
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>


        </div>

        <CoreFeature />
        <div className="faq-classic pt-0 bg-white">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="title-style-one mb-40">
                  <h6 className="font-rubik">Find your answers</h6>
                  <h2>Have any thought? Look here.</h2>
                </div>
              </div>
              <div className="col-lg-12">
                <div id="accordion" className="md-mt-60">
                  <div className="card">
                    <div className="card-header" id="headingOne">
                      <h5 className="mb-0">
                        <button
                          className="btn btn-link"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseOne"
                          aria-expanded="true"
                          aria-controls="collapseOne"
                        >
                          Can you place a call from your lead management CRM?
                        </button>
                      </h5>
                    </div>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse show"
                      data-bs-parent="#accordion"
                    >
                      <div className="card-body">
                        <p>
                          Yes, several sophisticated lead management CRM applications, such as TaskFlier, come with built-in telephony capabilities, enabling you to make calls from the CRM application itself. With this advancement, communication with your leads is a click away instead of switching between tools.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="headingTwo">
                      <h5 className="mb-0">
                        <button
                          className="btn btn-link"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseTwo"
                          aria-expanded="true"
                          aria-controls="collapseTwo"
                        >
                          What is Lead in Sales Management?
                        </button>
                      </h5>
                    </div>
                    <div
                      id="collapseTwo"
                      className="accordion-collapse collapse "
                      data-bs-parent="#accordion"
                    >
                      <div className="card-body">
                        <p>
                          A lead in sales is a prospective customer who has expressed interest in your product but is yet to convert.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="headingThree">
                      <h5 className="mb-0">
                        <button
                          className="btn btn-link"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseThree"
                          aria-expanded="true"
                          aria-controls="collapseThree"
                        >
                          What is Lead Management in CRM?
                        </button>
                      </h5>
                    </div>
                    <div
                      id="collapseThree"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordion"
                    >
                      <div className="card-body">
                        <p>
                          CRM refers to managing the selling process by capturing, tracking, managing, and converting leads using CRM software within customer relationships to improve sales.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="headingFour">
                      <h5 className="mb-0">
                        <button
                          className="btn btn-link"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseFour"
                          aria-expanded="true"
                          aria-controls="collapseFour"
                        >
                          Is Lead Management Part of CRM?
                        </button>
                      </h5>
                    </div>
                    <div
                      id="collapseFour"
                      className="accordion-collapse collapse "
                      data-bs-parent="#accordion"
                    >
                      <div className="card-body">
                        <p>
                          Yes. Lead management is a component of CRM that allows companies to consolidate and monitor their sales pipeline.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="headingFive">
                      <h5 className="mb-0">
                        <button
                          className="btn btn-link"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseFive"
                          aria-expanded="true"
                          aria-controls="collapseFive"
                        >
                          What are the Benefits of Lead Management Software?
                        </button>
                      </h5>
                    </div>
                    <div
                      id="collapseFive"
                      className="accordion-collapse collapse "
                      data-bs-parent="#accordion"
                    >
                      <div className="card-body">
                        <p>
                          Helps with data-driven insights, improves lead tracking, and follow-up automation, boosts conversion rates, and improves teammate collaboration.
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
    </>

  )
}

export default Leads
